<span
  #container
  tooltipPosition="top"
  tooltipZIndex="2100"
  [attr.styleLess]="styleLess() ?? undefined"
  [escape]="false"
  [hideDelay]="250"
  [life]="3000"
  [ngClass]="[
    'p-autocomplete ui-widget',
    dropdown ? 'p-autocomplete-dd' : '',
    multiple ? 'p-autocomplete-multiple' : '',
    styleClass || '',
  ]"
  [ngStyle]="style"
  pTooltip="{{ description }}"
  [showDelay]="500">
  @if (isLabelDisplay && label !== undefined && label !== null && label.trim().length > 0) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="inputId"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label">
      <span
        [ngClass]="{ autoCompleteLabelZoom: hasZoom && !preventLabelClick() }"
        (click)="!hasZoom || preventLabelClick() ? null : onLabelClickEmitter.emit()">
        {{ label }}
      </span>
    </label>
  }
  <div class="autocomplete-input-container">
    @if (!multiple) {
      <input
        #in
        autocomplete="off"
        data-cy="input-autocomplete"
        [attr.data-cy-columnName]="data?.columnName ?? columnName"
        [attr.data-cy-isstandalone]="isStandalone"
        [attr.id]="inputId"
        [attr.maxlength]="maxlength"
        [attr.placeholder]="placeholder"
        [attr.required]="required"
        [attr.size]="size"
        [attr.tabindex]="tabindex"
        [attr.type]="type"
        [attr.value]="inputFieldValue === undefined ? '' : inputFieldValue"
        [id]="inputId"
        [ngClass]="[
          'input-field p-inputtext ui-widget ui-state-default ui-corner-all p-autocomplete-input',
          mandatoryCss || '',
          inputStyleClass || '',
        ]"
        [ngStyle]="inputStyle"
        [readonly]="readonly"
        [style.font-size]="overridedCSS?.inputFontSize"
        [style.height]="overridedCSS?.inputHeight"
        [tabindex]="readonly ? '-1' : null"
        (blur)="onInputBlur($event)"
        (change)="onInputChange($event)"
        (click)="onInputClick($event)"
        (focus)="!readonly ? handleDropdownClick($event) : null"
        (input)="onInput($event)"
        (keydown)="onKeydown($event)"
        (keyup)="onKeyup($event)" />
    } @else {
      <ul
        #multiContainer
        data-cy="overlay-multiple-autocomplete"
        [ngClass]="[
          disabled ? 'p-disabled' : '',
          focus ? 'ui-state-focus' : '',
          'p-autocomplete-multiple-container ui-widget p-inputtext ui-state-default ui-corner-all p-autocomplete-input',
        ]"
        [ngStyle]="{ display: 'flex', float: 'left', overflow: 'hidden', 'margin-right': '-1px' }"
        (click)="multiIn.focus()">
        @if (value?.length) {
          @for (val of value; track val) {
            <li #token class="p-autocomplete-token p-highlight ui-corner-all">
              <ng-container [ngTemplateOutlet]="selectedItemTemplate" [ngTemplateOutletContext]="{ $implicit: val }" />
              @if (!selectedItemTemplate) {
                <span class="p-autocomplete-token-label">{{ val.displayValue }}</span>
              }
              @if (!disabled) {
                <span class="p-autocomplete-token-icon icon-close" (click)="removeItem(token)"></span>
              }
            </li>
          }
        }
        <!-- </div> -->
        <li class="p-autocomplete-input-token">
          <input
            #multiIn
            autocomplete="off"
            data-cy="input-autocomplete"
            [attr.data-cy-columnName]="data?.columnName ?? columnName"
            [attr.data-cy-isstandalone]="isStandalone"
            [attr.id]="inputId"
            [attr.placeholder]="value && value.length ? null : placeholder"
            [attr.tabindex]="tabindex"
            [attr.type]="type"
            class="{{ inputStyleClass }}"
            [ngStyle]="inputStyle"
            [readonly]="readonly"
            [tabindex]="readonly ? '-1' : null"
            (blur)="onInputBlur($event)"
            (change)="onInputChange($event)"
            (click)="onInputClick($event)"
            (focus)="!readonly ? onInputFocus($event) : null"
            (input)="onInput($event)"
            (keydown)="onKeydown($event)"
            (keyup)="onKeyup($event)" />
        </li>
      </ul>
    }
    @if (loading) {
      <i aria-hidden="true" class="p-autocomplete-loader icon-line-loader"></i>
    }
    @if (dropdown && !styleLess()) {
      <i
        #ddBtn
        aria-hidden="true"
        data-cy="input-autocomplete-lookup"
        type="button"
        [attr.data-cy-lookup-columnName]="data?.columnName ?? columnName"
        [ngClass]="['icon-search-bolder', iconeMandatoryCss || '']"
        [style.height]="overridedCSS?.inputHeight"
        (click)="
          checkSpecificView()
            ? !readonly && !disabled
              ? showFormPanel()
              : null
            : !readonly && !disabled
              ? data?.urlSearch
                ? !isEditorView
                  ? openSearchPanel()
                  : handleDropdownClick($event)
                : handleDropdownClick($event)
              : null
        "></i>
    }
  </div>

  @if (overlayVisible) {
    <div
      #panel
      [@overlayAnimation]="{ value: 'visible' }"
      [class]="panelStyleClass"
      [ngClass]="['p-autocomplete-panel p-component ui-widget-content ui-corner-all ui-shadow']"
      [ngStyle]="panelStyle"
      [style]="'overflow: auto; background: var(--prime-autocomplete-bg-color-panel);z-index: 9999;'"
      [style.max-height]="scrollHeight"
      (@overlayAnimation.start)="onOverlayAnimationStart($event)">
      <ul
        class="p-autocomplete-items p-autocomplete-list ui-widget-content ui-widget ui-corner-all ui-helper-reset"
        data-cy="overlay-autocomplete">
        @for (option of suggestions | autocompleteSuggestionsFilter: value; track $index) {
          <li
            [attr.data-cy-value]="field ? ObjectUtils.resolveFieldData(option, field) : option.displayValue"
            [ngClass]="[
              'p-autocomplete-list-item ui-corner-all',
              option.id === -1 ? 'moreResults' : '',
              highlightOption === option ? 'p-highlight' : '',
            ]"
            (click)="selectItem(option); $event.stopPropagation()"
            (mouseenter)="highlightOption = option"
            (mouseleave)="highlightOption = null">
            @if (!itemTemplate && option.id !== -1) {
              <span [style.font-size]="overridedCSS?.inputFontSize">
                {{ field ? ObjectUtils.resolveFieldData(option, field) : option.displayValue }}
              </span>
            }
            @if (!itemTemplate && option.id === -1) {
              <span class="moreResultsSpan" [style.font-size]="overridedCSS?.inputFontSize">
                {{ field ? ObjectUtils.resolveFieldData(option, field) : option.displayValue }}
              </span>
            }
            <ng-container
              [ngTemplateOutlet]="itemTemplate"
              [ngTemplateOutletContext]="{ $implicit: option, index: $index }" />
          </li>
        }
        @if (noResults && emptyMessage) {
          <li class="p-autocomplete-list-item ui-corner-all">
            {{ emptyMessage }}
          </li>
        }
      </ul>
    </div>
  }
</span>
